import { store } from '../../../store'
import { MessageDataType } from '../types'
import { getBarType } from '../../../utils/datafeed/bar'
import { updateLastBarAction } from '../../../store/market/actions'
import { SymbolName } from '../../../types'
import { BarDataItem, Resolution } from '../../../api/v1/market'

export interface WsLatBarData {
  type: 'bar'
  symbol: SymbolName
  resolution: Resolution
  data: BarDataItem
}

export function onMessageLastBar(data: MessageDataType) {
  switch (data.type) {
    case 'bar':
      updateLastBar(data as WsLatBarData)
      break
  }
}

function updateLastBar(data: WsLatBarData) {
  const resolution = store.getState().orderbook.resolution
  const type = getBarType(resolution)
  const r = data.data
  if (type === data.resolution) {
    store.dispatch(
      updateLastBarAction({
        symbol: data.symbol,
        time: r[0],
        open: r[1],
        high: r[2],
        low: r[3],
        close: r[4],
        volume: r[5],
      })
    )
  }
}
